import React from 'react'
import { BillItemListing } from './BillItemListing'
import { BillItemImportExcelValidation } from './BillItemExcelValidation'

export const billItemRoutes = [
  // {
  //   props: {
  //     exact: true,
  //     path: `/common-setting/bill-items`,
  //   },
  //   component: <BillItemListing />,
  // },
  {
    props: {
      exact: true,
      path: `/account-receivable/general-setting/bill-items`,
    },
    component: <BillItemListing accountType="account-receivable" />,
  },
  {
    props: {
      exact: true,
      path: `/account-receivable/general-setting/bill-items/import-bill-item-validation/:BatchID`,
    },
    component: (
      <BillItemImportExcelValidation accountType="account-receivable" />
    ),
  },
]

export default billItemRoutes
